export default __webpack_public_path__ + "static/media/Parag.cb5ddca0.jpeg";